module.exports = __webpack_public_path__ + "img/四川天府新区华夏孔子幼儿园.830eccce.jpg";